<template>
  <Landing />
</template>

<script>
import Landing from '../views/Landing.vue';

export default {
  name: 'AppLanding',
  components: { Landing },
};
</script>
